<template>
<print-layout>
        <div class="print-container">
            <div>
                <div class="text-4xl">
                    <span class="text-green"><b>PRODUCE</b></span>
                    <span class="ml-2 text-red"><b>EXPRESS</b></span>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold w-1/2">
                                Customer Info
                            </th>
                            <th class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold w-1/2">
                                Order Info
                            </th>
                        </tr>
                        <tr>
                            <td class="font-semibold align-top">
                                <div>{{ order.customer.name }}</div>
                                <div v-show="order.customer.address_2">{{ order.customer.address_1 }}</div>
                                <div class="mb-2">{{ order.customer.city }} {{ order.customer.province }} {{ order.customer.postal_code }}</div>
                                <div v-show="order.customer.phone">T: {{ order.customer.phone }}</div>
                                <div v-show="order.customer.emails">
                                    <ul class="leading-tight">
                                        <li v-for="email in order.customer.emails" :key="email">{{ email }}</li>
                                    </ul>
                                </div>
                            </td>
                            <td class="font-semibold align-top">
                                <div><span class="inline-block w-32">Order #:</span>{{ order.id }}</div>
                                <div><span class="inline-block w-32 whitespace-nowrap">Ordered On:</span>{{ order.order_date }}</div>
                                <div>
                                    <span class="inline-block w-32 whitespace-nowrap">
                                        {{ order.shipping_method === 'pickup' ? 'Pickup' : 'Ship' }} Date:
                                    </span>
                                    {{ order.ship_date }}
                                </div>
                            </td>
                        </tr>
                    </thead>
                </table>
                <table class="w-3/4">
                    <tbody class="striped">
                        <tr class="not_striped">
                            <th colspan="4" class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold">
                                Order Details
                            </th>
                        </tr>
                        <tr class="not_striped border-b border-gray">
                            <th class="py-1 text-left w-1/12">Quantity</th>
                            <th class="py-1 text-left pl-2">Item</th>
                            <th class="py-1 text-center pr-5 w-1/12">Price</th>
                            <th class="py-1 text-right whitespace-nowrap w-1/12">Line Total</th>
                        </tr>
                        <tr v-for="(item, index) in order.order_items" :key="index" class="border-b border-gray">
                            <td class="text-left">{{ item.quantity }}</td>
                            <td class="text-left pl-2">{{ item.title }}</td>
                            <td class="text-right pr-4">{{ toCurrency(item.price) }}</td>
                            <td class="text-right">{{ toCurrency(item.quantity * item.price) }}</td>
                        </tr>
                        <tr class="not_striped">
                            <th colspan="3" class="text-right pt-2">Subtotal:</th>
                            <td class="text-right pt-2">{{ toCurrency(subtotal(order)) }}</td>
                        </tr>
                        <tr class="not_striped">
                            <th colspan="3" class="text-right">Tax:</th>
                            <td class="text-right">{{ toCurrency(tax(order)) }}</td>
                        </tr>
                        <tr class="not_striped">
                            <th colspan="3" class="text-right">Total:</th>
                            <td class="text-right">{{ toCurrency(total(order)) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="page-break"></div>
            </div>
        </div>
    </print-layout>
</template>

<script>
import PrintLayout from '@/Layouts/PrintLayout.vue';

export default {

    components: {
        PrintLayout,
    },

    props: ['order'],

    methods: {
        subtotal(order) {
            return order.order_items.reduce(function(accumulator, currentValue){
                return accumulator + (currentValue.quantity * currentValue.price);
            }, 0);
        },
        tax(order) {
            return order.order_items.reduce(function(accumulator, currentValue){
                return accumulator + (currentValue.tax === true ?  (currentValue.quantity * currentValue.price * 0.13) : 0);
            }, 0);
        },
        total(order) {
            return this.subtotal(order) + this.tax(order);
        }
    },

    mounted () {
        window.print();

        window.onafterprint = function() {
            window.close();
        };
        window.onfocus = function() {
            window.close();
        };
    }

}
</script>

<style scoped>
    body {
        font-size: 90%;
    }

    table {
        width: 100%;
    }

    table td {
        -webkit-print-color-adjust: exact;
    }

    .page-break {
        page-break-after: always;
    }

    .subheader th {
        background: #cbcbcb;
        -webkit-print-color-adjust: exact;
    }

    @media screen {
        .print-container {
            display: none;
        }
    }

    .striped tr:nth-child(even):not(.not_striped) {
        background-color: #f2f2f2;
    }
</style>
